import React from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
const Icon = styled.svg``;

const PlayIcon = ({
  theme,
  viewBox,
  height,
  width
}) => /*#__PURE__*/React.createElement(Icon, {
  viewBox: viewBox,
  height: height,
  width: width,
  version: "1.1",
  "aria-label": "video",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, /*#__PURE__*/React.createElement("path", {
  fill: theme.base.white,
  fillRule: "evenodd",
  d: "M0 0l12 6.857-12 6.857z"
}));

PlayIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  viewBox: PropTypes.string,
  theme: PropTypes.shape({
    base: PropTypes.shape({
      white: PropTypes.string
    })
  })
};
PlayIcon.defaultProps = {
  height: '15',
  width: '12',
  viewBox: null,
  theme: null
};
export default withTheme(PlayIcon);